// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1PV6i","legacyBtn":"MutateMid_legacyBtn__T-9G0"};